import { createFileRoute, Link } from '@tanstack/react-router';
import { seo } from '~/util';

export const Route = createFileRoute('/terms')({
    head: () => ({
        meta: seo({
            title: 'Terms of Service',
            description:
                'Terms of Service for using the All Rated Extreme Demons List.',
        }),
    }),
    component: TermsPage,
});

function TermsPage() {
    return (
        <div className="mx-auto w-full max-w-5xl px-4 py-6">
            <div className="bg-background-dark/80 backdrop-blur-md rounded-xl p-6 md:p-8 shadow-md border border-gray-800">
                <article className="prose prose-invert max-w-none leading-5 [&>*+*]:mt-2  [&_a]:text-primary [&_a]:font-semibold [&_a]:hover:underline">
                    <h1>Terms of Service</h1>
                    <p>
                        <strong>Last Updated: June 21, 2026</strong>
                    </p>

                    <br />

                    <p>
                        By accessing or using the All Rated Extreme Demons List
                        (AREDL) website, platform, or related services, you
                        agree to follow these Terms of Service. If you do not
                        agree to these Terms, you should not use AREDL.
                    </p>

                    <br />

                    <p>
                        You must be at least 13 years old to use AREDL. Because
                        AREDL uses Discord for login, you must also meet
                        Discord&apos;s minimum age requirements. If Discord
                        requires a higher minimum age in your country, that
                        higher age requirement applies.
                    </p>

                    <p>
                        Authentication is handled through Discord OAuth 2.0. You
                        are responsible for keeping your Discord account secure
                        and for all activity performed through your
                        authenticated account.
                    </p>

                    <p>
                        You may not share your account with others. Multiple
                        accounts for the same user are not allowed unless AREDL
                        staff gives explicit permission.
                    </p>

                    <p>
                        Users may request removal or redaction of their account
                        information. Some submission or moderation history may
                        still be kept if needed for list history, staff review,
                        bans, or abuse prevention. Users may also mark their
                        account as unranked, or request a ban of their own
                        account.
                    </p>

                    <br />

                    <p>
                        You agree not to submit false, misleading, manipulated
                        or stolen records or content. You also agree not to
                        abuse, harass, threaten, impersonate, or target other
                        users or staff members.
                    </p>

                    <p>
                        You may not submit spam, malicious links, harmful files,
                        inappropriate material, or content that violates site
                        rules. You may not attempt to bypass security measures,
                        exploit bugs or disrupt service.
                    </p>

                    <p>
                        You are responsible for the content you submit to AREDL,
                        including record information, video links, notes, files,
                        etc.
                    </p>

                    <p>
                        AREDL staff may remove, edit, hide, or reject
                        submissions that violate these Terms or the{' '}
                        <Link to="/guidelines">Submission Guidelines</Link>. A
                        submission may also be hidden from public view if its
                        public-facing content is offensive, inappropriate, or
                        otherwise unsuitable, even if the completion itself is
                        considered legitimate.
                    </p>

                    <p>
                        Users may request an appeal through the AREDL Discord
                        server support channels or through{' '}
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdShAWmdqnvmM-L_qUoysS5FgE8RJIoEdxVMWAFeQWldcVwJg/viewform?usp=header">
                            this google form
                        </a>
                        .
                    </p>

                    <br />

                    <p>
                        The AREDL is provided as is and may change, break, or
                        become unavailable at any time. We do not guarantee that
                        the AREDL will always be available, accurate, complete,
                        or error-free.
                    </p>

                    <p>
                        List placements, leaderboard data, profile data, record
                        information, and other site content may be updated,
                        corrected, hidden, or removed when needed.
                    </p>

                    <p>
                        AREDL relies on third-party services such as Discord,
                        YouTube, Patreon, and Cloudflare. We are not responsible
                        for issues caused by third-party services, including
                        outages, account problems, deleted content, unavailable
                        links, or changes to those services.
                    </p>

                    <p>
                        We may update these Terms from time to time. When we do,
                        the updated version will be posted on this page.
                        Continuing to use AREDL after changes are posted means
                        you accept the updated Terms.
                    </p>

                    <p>
                        For questions about these Terms, contact us through the
                        AREDL Discord server.
                    </p>
                </article>
            </div>
        </div>
    );
}
